import teams from "./assets/service-logos/msteams.png";
import zoom from "./assets/service-logos/zoom.png";
import webex from "./assets/service-logos/webex.png";
import googlemeet from "./assets/service-logos/googlemeet.png";
import slack from "./assets/service-logos/slack.png";
import gotomeeting from "./assets/service-logos/gotomeeting.png";

export const serviceLogos = { msteams: teams, zoom, webex, googlemeet, slack, gotomeeting };
const aliases = { teams: "msteams", microsoftteams: "msteams", ciscowebex: "webex", gotomeeting: "gotomeeting" };

export function serviceLogoSource(service) {
  for (const name of [service.ServiceName, service.ServiceDisplayName]) {
    const key = (name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    if (serviceLogos[aliases[key] || key]) return serviceLogos[aliases[key] || key];
  }
  return service.ServiceName ? `https://www.signaltuner.com/images/serviceicons/${encodeURIComponent(service.ServiceName)}.png` : null;
}
